/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Badge_TitleInputs */

const en_directory_submit_badge_title = /** @type {(inputs: Directory_Submit_Badge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get a free dofollow link`)
};

const zh_directory_submit_badge_title = /** @type {(inputs: Directory_Submit_Badge_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费获得 dofollow 外链`)
};

/**
* | output |
* | --- |
* | "Get a free dofollow link" |
*
* @param {Directory_Submit_Badge_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_badge_title = /** @type {((inputs?: Directory_Submit_Badge_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Badge_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_badge_title(inputs)
	return zh_directory_submit_badge_title(inputs)
});
export { directory_submit_badge_title as "directory.submit.badge_title" }